"use strict";

import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";
import { user } from "Models/UserModel";
import { Model } from "Model";
import { Collection } from "Collection";
import { SystemConfig } from "Constants/SystemCfg";
import moment from "moment";
import { UserSettings } from "D5Utils/UserSettings";
export function formatNumberPrecision(value, precision) {
  // if (precision == null)
  return value; // return Number(Number.parseFloat(value).toPrecision(precision || 5));
}
export function getDatePlaceholder(type) {
  return formatText(type, new Date()).replace(/(\d)/g, '0');
}
export function deleteAllCookies() {
  document.cookie.split(";").forEach(function (c) {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
}
export function setReturnUrl() {
  var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var returnUrl = hash || window.location.hash.slice(1);
  if (returnUrl !== System.login) localStorage.setItem(System.ReturnUrl, returnUrl);
}
export function isDateByTypeStr(type) {
  return type === 'date' || type === 'datetime';
}
export function objectsEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
/**
 * @param {string} type
 * @param {string|Date} value
 * @return {string}
 */

export function formatText(type, value) {
  var regSett = UserSettings.getRegionalSettings()[Fields.RegionalLocale];
  var lang = regSett && "".concat(regSett, "-").match(/(\w+)-/)[1];

  switch (type) {
    case System.FIELD_EDITOR_TYPE.DATE:
      return Globalize.formatDate(new Date(value));

    case System.FIELD_EDITOR_TYPE.DATETIME:
      return Globalize(lang).dateFormatter({
        datetime: "short"
      })(new Date(value));

    case System.FIELD_EDITOR_TYPE.NUMBER:
      return Globalize.formatNumber(Number.parseFloat(value));

    default:
      return value;
  }
}
/**
 * @param {object} field
 * @param {function} [callBack]
 * @param {object} [context]
 * @return {string}
 */

export function getFieldFormat(field, callBack, context) {
  var type = getControlDXType(field);
  if (typeof callBack === 'function') type = callBack.call(context, field);
  var numberScale = field[Fields.ObjectFieldID_NumberScale];
  var withTime = field[Fields.ObjectFieldID_IsTimeAllowed];

  switch (type) {
    case 'number':
    case System.DX_CONTROLS.dxNumberBox:
      return numberScale != null ? "#0.".concat(Array(numberScale).fill('0').join('')) : '';

    case 'date':
    case 'datetime':
    case System.DX_CONTROLS.dxDateBox:
      {
        if (withTime) return 'datetime';
        return 'date';
      }
  }
}
export function createTableID(formID, parentFormID) {
  var id = "".concat(user.getUserID(), "-table-").concat(formID);
  if (parentFormID != null) id += "-".concat(parentFormID);
  return id;
}
export function createTreeListID(formID, parentFormID) {
  var id = "".concat(user.getUserID(), "-tree-view-").concat(formID);
  if (parentFormID != null) id += "-".concat(parentFormID);
  return id;
}
export function createTableComponentID(formID, parentFormID, formType) {
  switch (formType) {
    case System.FORM_TYPE.LIST:
      return createTableID(formID, parentFormID);

    case System.FORM_TYPE.TREE:
      return createTreeListID(formID, parentFormID);
  }
}
/**
 * @param {string} componentOperation
 * @return {string}
 */

export function operationFactory(componentOperation) {
  switch (componentOperation) {
    case 'contains':
      return 'like';

    case '<>':
      return '!=';

    default:
      return componentOperation;
  }
}
/**
 * @param {string} dictObj
 * @param {string} dictKeyFld
 * @param {string} dictDisplayFld
 * @param {array} _filter
 */

export function createSelectFieldDS(dictObj, dictKeyFld, dictDisplayFld) {
  var _filter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  return new DevExpress.data.DataSource({
    load: function load(loadOptions) {
      return getSelectFieldData(loadOptions, dictObj, dictKeyFld, dictDisplayFld);
    },
    paginate: true,
    pageSize: 20,
    filter: _filter == null || !_filter.length ? null : _filter,
    byKey: function byKey(key) {
      if (Array.isArray(key) && !key.length) return Promise.resolve();
      return new Promise(function (resolve) {
        var ObjectModel = Model.extend({
          initialize: function initialize() {
            this.object = dictObj;
          }
        });
        new ObjectModel().fetch({
          data: {
            Columns: [dictKeyFld, dictDisplayFld],
            Filters: _defineProperty({}, dictKeyFld, {
              '=': key
            }),
            Sorts: [dictDisplayFld]
          },
          success: function success(res) {
            resolve(res.toJSON());
          }
        });
      });
    }
  });
}
/**
 * @param {object} loadOptions
 * @param {string} dictObject
 * @param {string} dictKeyFld
 * @param {string} displayFld
 * @return {Promise}
 */

export function getSelectFieldData(loadOptions, dictObject, dictKeyFld, displayFld) {
  return new Promise(function (resolve) {
    var objectModel = Model.extend({
      initialize: function initialize() {
        this.object = dictObject;
      }
    });
    var objectCollection = new (Collection.extend({
      model: objectModel,
      object: dictObject
    }))();
    var fltr = {};
    if (loadOptions.filter != null) fltr = prepareFilterForSelect(loadOptions.filter);

    if (loadOptions.searchValue != null) {
      fltr[displayFld] = {
        'like': loadOptions.searchValue
      };
    }

    objectCollection.fetch({
      data: {
        Page: (loadOptions.skip + loadOptions.take) / loadOptions.take,
        RowsPerPage: loadOptions.take,
        Columns: [dictKeyFld, displayFld],
        Filters: fltr,
        Sorts: [displayFld]
      },
      success: function success(collection) {
        var data = collection.toJSON().filter(function (item) {
          return item[displayFld] != null;
        });
        resolve(data);
      }
    });
  });
}
export function prepareFilterForSelect(filter) {
  var out = {};
  if (filter == null) return out;
  var FIELD = 0,

  /*OPER = 1,*/
  VAL = 2;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = filter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var fil = _step.value;

      if (Array.isArray(fil)) {
        var fld = fil[FIELD],
            val = fil[VAL];

        if (out.hasOwnProperty(fld)) {
          out[fld].push(val);
        } else {
          Array.isArray(val) ? out[fld] = val : out[fld] = [val];
        }
      } else if (fil !== 'or') {
        var _fld = filter[FIELD];
        out[_fld] = filter[VAL];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return out;
}
export function getTitlePosition(field) {
  switch (field[Fields.TitlePosition]) {
    case System.TITLE_POSITION.LEFT:
      return 'left';

    case System.TITLE_POSITION.RIGHT:
      return 'right';

    default:
      return 'top';
  }
}
/**
 * @param {Date} date
 * @param {Boolean|Number} withTime [false]
 */

export function formatDateToAPI(date) {
  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (withTime) return moment(date).format('YYYY-MM-DDTHH:mm:ss');
  return moment(date).format('YYYY-MM-DD');
}
/**
 * @param {String} text
 * @param {Array} [args=[]]
 * @return {String}
 * @example
 * formatMessage("Hello, {0}!", ["World"])
 */

export function formatMessage(text) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var str = text;

  for (var v in args) {
    str = str.replace("{".concat(v, "}"), args[v] == null ? '' : args[v]);
  }

  return str;
}
/**
 * @param {String} path
 * @param {String} name
 */

export function getSystemParam(path, name) {
  return window.CustomConfig && window.CustomConfig[path] && window.CustomConfig[path][name] ? window.CustomConfig[path][name] : SystemConfig[path] && SystemConfig[path][name];
}
export function createGuid() {
  return new DevExpress.data.Guid().toString();
}
/**
 * @param {String} formName
 * @param {String} funcName
 */

export function checkIfUserScriptExists(formName, funcName) {
  return window[formName] && typeof window[formName][funcName] === 'function';
}
export function columnType(type) {
  var withTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  switch (type) {
    case System.FIELD_TYPE.NUMBER:
      return 'number';

    case System.FIELD_TYPE.DATE:
      if (withTime) return 'datetime';
      return 'date';

    case System.FIELD_TYPE.BOOL:
      return 'boolean';

    default:
      return 'string';
  }
}
export function isEmptyObject() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(object).length === 0;
}
export function isEmptyValue(value) {
  if (value == null) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (value instanceof Date) return false;
  return !!(_typeof(value) === 'object' && isEmptyObject(value));
} //localStorage settings -------------------------------------------------------

export function getAddFilter(lsName) {
  return JSON.parse(localStorage.getItem("".concat(lsName, "-filter")) || '{}');
}
export function setAddFilter(lsName, value) {
  return localStorage.setItem("".concat(lsName, "-filter"), JSON.stringify(value));
}
export function getLSTableCols(lsName) {
  return JSON.parse(localStorage.getItem("".concat(lsName)) || '[]');
}
export function setLSTableCols(lsName, value) {
  return localStorage.setItem(lsName, JSON.stringify(value));
}
export function getShowRowFilter(lsName) {
  return JSON.parse(localStorage.getItem("".concat(lsName, "-row-filter")) || '{}');
}
export function setShowRowFilter(lsName, value) {
  return localStorage.setItem("".concat(lsName, "-row-filter"), JSON.stringify(value));
} //sessionStorage settings -------------------------------------------------------

export function getAddSSFilter(lsName) {
  return JSON.parse(sessionStorage.getItem("".concat(lsName, "-filter")) || '{}');
}
export function setAddSSFilter(lsName, filter) {
  var tmp = {};

  if (!isEmptyValue(filter)) {
    for (var field in filter) {
      if (filter.hasOwnProperty(field) && filter[field].hasOwnProperty('realOperation') && filter[field].hasOwnProperty('filterValue') && filter[field].filterValue && !isEmptyValue(filter[field].filterValue)) {
        tmp[field] = filter[field];
      }
    }
  }

  return sessionStorage.setItem("".concat(lsName, "-filter"), JSON.stringify(tmp));
}
export function getSSTableCols(lsName) {
  return JSON.parse(sessionStorage.getItem("".concat(lsName)) || '[]');
}
export function setSSTableCols(lsName, value) {
  return sessionStorage.setItem(lsName, JSON.stringify(value));
}
export function getShowRowSSFilter(lsName) {
  return JSON.parse(sessionStorage.getItem("".concat(lsName, "-row-filter")) || '{}');
}
export function setShowRowSSFilter(lsName, value) {
  return sessionStorage.setItem("".concat(lsName, "-row-filter"), JSON.stringify(value));
} //-----------------------------------------------------------------------------

export function itemWithIconTemplate(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      titleType = _ref.titleType,
      type = _ref.type;
  var titleHtml = '',
      iconStyleClass = 'icon-margin-right';
  var _System$TITLE_TYPE = System.TITLE_TYPE,
      ICON = _System$TITLE_TYPE.ICON,
      ICON_AND_TITLE = _System$TITLE_TYPE.ICON_AND_TITLE;

  var _iconLibByIcon = iconLibByIcon(icon),
      iconLibrary = _iconLibByIcon.iconLibrary,
      iconClass = _iconLibByIcon.iconClass;

  switch (type) {
    case System.TEMPLATE_TYPE.BUTTON:
      titleHtml = "<span class=\"dx-button-text\">".concat(text, "</span>");
      break;

    case System.TEMPLATE_TYPE.TITLE:
    default:
      titleHtml = text;
  }

  var iconHtml = prepareIcon({
    iconLibrary: iconLibrary,
    iconClass: iconClass,
    iconStyleClass: iconStyleClass
  });
  var $div = $('<div/>');
  var $span = prepareSpan(iconLibrary);

  switch (titleType) {
    case ICON:
      $span.append(iconHtml || titleHtml);
      break;

    case ICON_AND_TITLE:
      $span.append(iconHtml);
      $span.append(titleHtml);
      break;

    default:
      $span.append(titleHtml);
  }

  $div.append($span);
  return $div.html();
}

function prepareSpan(iconLibrary) {
  if (iconLibrary === 'material2') return $('<span class="icon material2-icon"/>');else return $('<span class="icon"/>');
}

function iconLibByIcon(icon) {
  icon = icon || '';
  var iconLibrary = icon.split(':')[0];
  var iconClass = icon.split(':')[1];
  return {
    iconLibrary: iconLibrary,
    iconClass: iconClass
  };
}

function prepareIcon(_ref2) {
  var iconLibrary = _ref2.iconLibrary,
      iconClass = _ref2.iconClass,
      iconStyleClass = _ref2.iconStyleClass;

  switch (iconLibrary) {
    case 'material':
      return "<i class=\"material-icons ".concat(iconStyleClass, "\">").concat(iconClass, "</i>");

    case 'material2':
      return "<i class=\"material2-icons ".concat(iconStyleClass, " ").concat(iconClass, "\"/>");

    case 'fontawesome':
      return "<i class=\"fontawesome-icons ".concat(iconStyleClass, " ").concat(iconClass, "\"/>");

    default:
      return '';
  }
}
/**
 * @param {Object} field FormField
 * @return {string}
 */


export function getControlDXType(field) {
  var fieldType = field[Fields.ObjectFieldID_FieldType];

  if (isLookup(field)) {
    return System.DX_CONTROLS.dxSelectBox;
  }

  switch (fieldType) {
    case System.FIELD_TYPE.NUMBER:
      return System.DX_CONTROLS.dxNumberBox;

    case System.FIELD_TYPE.DATE:
      return System.DX_CONTROLS.dxDateBox;

    case System.FIELD_TYPE.BOOL:
      return System.DX_CONTROLS.dxCheckBox;

    case System.FIELD_TYPE.BUTTON:
      return System.DX_CONTROLS.dxButton;

    case System.FIELD_TYPE.DECORATION:
      return System.FIELD_TYPE.DECORATION;

    default:
      return field[Fields.LineCount] > 1 ? System.DX_CONTROLS.dxTextArea : System.DX_CONTROLS.dxTextBox;
  }
}
/**
 * @param {Object} field FormField
 * @return {string}
 */

export function getD5EditorType(field) {
  if (isLookup(field)) return System.FIELD_EDITOR_TYPE.SELECT;
  var type = getControlDXType(field);

  switch (type) {
    case System.DX_CONTROLS.dxCheckBox:
      return System.FIELD_EDITOR_TYPE.BOOL_CB;

    case System.DX_CONTROLS.dxNumberBox:
      return System.FIELD_EDITOR_TYPE.NUMBER;

    case System.DX_CONTROLS.dxDateBox:
      {
        if (field[Fields.ObjectFieldID_IsTimeAllowed]) return System.FIELD_EDITOR_TYPE.DATETIME;
        return System.FIELD_EDITOR_TYPE.DATE;
      }

    case System.DX_CONTROLS.dxTextBox:
      return System.FIELD_EDITOR_TYPE.TEXT;
  }
} //FORM helpers ----------------------------------------------------------------------------

/**
 * @param {Object} field FormField
 * @return {boolean}
 */

export function isLookup(field) {
  return Boolean(getLinkedName(field) && (getDisplayObjectFieldIDName(field) || getObjLinkedDisplayName(field)));
}
/**
 * @param {Object} field FormField
 * @return {string}
 */

export function getLinkedName(field) {
  return field[Fields.ObjectFieldID_LinkedObjectID_Name];
}
/**
 * @param {Object} field FormField
 * @return {string}
 */

export function getKeyObjFieldName(field) {
  return field[Fields.ObjectID_KeyObjectFieldID_Name];
}
/**
 * @param {Object} field FormField
 * @return {string}
 */

export function getObjLinkedKeyName(field) {
  return field[Fields.ObjectFieldID_KeyObjectFieldID_Name];
}
/**
 * @param {Object} field FormField
 * @return {string}
 */

export function getObjLinkedDisplayName(field) {
  return field[Fields.ObjectFieldID_DisplayObjectFieldID_Name];
}
/**
 * @param {Object} field FormField
 * @return {string}
 */

export function getDisplayObjectFieldIDName(field) {
  return field[Fields.ObjectFieldID_DisplayObjectFieldID_Name];
}
/**
 * @param {Object} field FormField
 * @return {number}
 */

export function getObjectFieldType(field) {
  return field[Fields.ObjectFieldID_FieldType];
}
/**
 * @param {Object} field FormField
 * @return {boolean}
 */

export function fieldHasGroup(field) {
  return field[Fields.GroupID] != null;
} //FORM helpers ----------------------------------------------------------------------------